import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BudgetService {

  constructor(private httpClient: HttpClient) { }

  async getBudgetListByCondition(param: any, pageNum: number, pageSize: number) {
    let url = `plan/api/business/budget/budgets?pageNum=${pageNum}&pageSize=${pageSize}`;
    if (!this.isEmpty(param.bName)) {
      url = url + `&bname=${param.bName}`;
    }
    if (!this.isEmpty(param.bYear)) {
      const date = new Date(param.bYear);
      url = url + `&byear=${date.getFullYear()}`;
    }
    if (!this.isEmpty(param.userId)) {
      url = url + `&userId=${param.userId}`;
    }
    if (!this.isEmpty(param.status)) {
      url = url + `&status=${param.status}`;
    }
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  async getBudget(pbid: any) {
    const url = `plan/api/business/budget/budget/${pbid}`;
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  async getBudgetWithPrice(pbid: any) {
    const url = `plan/api/business/budget/budget/detailPrice/${pbid}`;
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  // 用于表格导出
  async getBudgetsByBids(bids: string) {
    const url = `plan/api/business/budget/budgets/${bids}`;
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  async batchDelete(ids: any) {
    const ls: string[] = Array.from(ids);
    const result: any = await this.httpClient.delete(`plan/api/business/budget/budgets/`, { params: { ids: ls } }).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  async updateBudget(budget: any) {
    const result: any = await this.httpClient.put(`plan/api/business/budget/budget/`, budget).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result;
  }

  // 根据预算id更新明细集合
  async updateBudgetDetails(budget: any) {
    const result: any = await this.httpClient.put(`plan/api/business/budget/budget/details`, budget).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result;
  }

  async addBudget(budget) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    const result: any = await this.httpClient.post(`plan/api/business/budget/budget/`, budget, httpOptions).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }
  // 获取预算状态
  getBudgetStatus(): Observable<any[]> {
    return this.httpClient.get(`plan/api/business/budget/status`).pipe(
      map((res: { data: any[] }) => res.data)
    );
  }



  // 根据bid获取月度预算集合
  async getBudgetMonthsByBid(bid: any) {
    const url = `plan/api/business/budget/budgetMonths/${bid}`;
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  // 根据月度预算id删除月度预算
  async deleteByMbid(mbid: any) {
    const result: any = await this.httpClient.delete(`plan/api/business/budget/budgetMonths/${mbid}`).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result;
  }

  // 添加一条月度预算
  async addBudgetMonth(budgetMonth: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    const result: any = await this.httpClient.post(`plan/api/business/budget/budgetMonths`, budgetMonth, httpOptions).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  // 更新一条月度预算
  async updateBudgetMonth(budgetMonth: any) {
    const result: any = await this.httpClient.put(`plan/api/business/budget/budgetMonths`, budgetMonth).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result;
  }

  // 根据mbid查询一条月度预算
  async getBudgetMonthByMbid(mbid: any) {
    const url = `plan/api/business/budget/budgetMonth/${mbid}`;
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  // 根据年度预算id，查询该条年度预算下，所有月度预算的明细
  async getMonthsDetailsByBid(bid: any) {
    const url = `plan/api/business/budget/budgetMonth/months/${bid}`;
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  // 预算年度统计
  async getAllBudget(date: Date) {
    let url = `plan/api/business/budget/all`;
    url = url + `?year=${date.getFullYear()}`;
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  // 预算月度统计
  async monthBudgetStatistics(
    year: number
  ) {
    let url = `plan/api/business/budget/monthBudgetStatistics`;
    if (year !== undefined && year !== null) {
      url = url + `?year=${year}`;
    }
    const result: any = await this.httpClient.get(url).toPromise();
    if (result == null || result.code !== 200 || result.data == null) {
      return null;
    }
    return result.data;
  }

  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }

}
